<template>
  <div class="PaginationCss" v-show="pagination.pageTotal>0">
    <el-pagination
    background
    v-show="pageAdapter"
    small
    :page-size="pagination.pageSize"
    :pager-count="5"
    layout="prev, pager, next"
    :total="pagination.pageTotal"
    @current-change="current_change">
    </el-pagination>

    <el-pagination
    background
    v-show="!pageAdapter"
    :page-size="pagination.pageSize"
    layout="prev, pager, next"
    :total="pagination.pageTotal"
    @current-change="current_change">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      pageAdapter: true
    };
  },
  props: ["pagination"],
  methods: {
    current_change: function(currentPage) {
      this.$emit('paginationClick', currentPage); 
    }
  },
  mounted: function() {
    console.log(this.pagination)
    if (this.common.getClient()){
      this.pageAdapter = true
    }else {
      this.pageAdapter = false
    }
  }
};
</script>

<style>

.PaginationCss {
  padding: 15px 5px;
  align-items: center;
  align-content: center;
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/common/util/pagination.vue